import api from "./core";

const basePath = "api/portal/PatientPaymentMethod";

export default {
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(patientId) {
    return api.post(`${basePath}/${patientId}`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
